import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/siembra';
import Siembra from './SiembraList';

const ms2p = (state) => {
  return {
    ...state.siembra_prd,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Siembra);
